var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-foot"},[_c('div',[_vm._v("辽宁交投e工会")]),_c('div',[_vm._v("交投集团")])])
}]

export { render, staticRenderFns }